import {
    SEARCH_USER_ACTION_REQUEST,
    SEARCH_USER_ACTION_SUCCESS,
    SEARCH_USER_ACTION_FAILURE,
    SEARCH_USER_CLEAR_ACTION
} from './constants';

import {
    SearchUserAction,
    ClearSearchUserAction
} from './typedef';

type IActions = SearchUserAction & ClearSearchUserAction;

const defaultState = {
    searchUsers: [],
    preloader: false
};

const searchUserReducer = (state: any = defaultState, action: IActions) => {
    switch (action.type) {
        case SEARCH_USER_ACTION_REQUEST:
            return {
                ...state,
                searchUsers: [],
                preloader: true
            };
        case SEARCH_USER_ACTION_SUCCESS:
            return {
                ...state,
                searchUsers: action.data || [],
                preloader: false
            };
        case SEARCH_USER_ACTION_FAILURE:
            return {
                ...state,
                value: 'error'
            };
        case SEARCH_USER_CLEAR_ACTION:
            return {
                ...state,
                searchUsers: []
            };
        default :
            return state;
    }

};

export {searchUserReducer};
